import { render, staticRenderFns } from "./iconModif.vue?vue&type=template&id=10789ff4"
import script from "./iconModif.vue?vue&type=script&lang=js"
export * from "./iconModif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports